import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  drawer: {
    width: 320,
    flexShrink: 0
    // overflow: 'hidden'
  },
  drawerPaper: {
    width: 320,
    display: 'flex',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    overflowX: 'auto',
    ...theme.scrollbarStyles
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderLeft:
      '1px solid ' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_stroke.main),
    borderRadius: 4,
    width: '100%',
    maxWidth: 320,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: '8px 12px'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    ...theme.scrollbarStyles,
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px'
  },
  contactAvatar: {
    width: '100px',
    height: '100px',
    cursor: 'pointer'
  },
  contactName: {
    fontSize: '18px',
    fontWeight: '500',
    lineWeight: '10',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    overflow: 'hidden',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    maxWidth: '100%',
    textAlign: 'center',
    lineHeight: '1.2'
  },
  contactNumber: {
    fontSize: '16px',
    color: theme.palette.blue_300.main,
    textAlign: 'center',
    '& a': {
      color: theme.palette.blue_300.main
    }
  },
  containerContactPhone: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '2px'
  },

  contactHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%', // Limita o tamanho máximo
    overflow: 'hidden' // Garante que conteúdo extra seja tratado
  },

  contactDetails: {
    marginTop: 8,
    padding: 12,
    display: 'flex',
    flexDirection: 'column'
  },
  contactDetailsTitle: {
    fontWeight: '500',
    color: theme.palette.gray_400.main,
    fontSize: '16px',
    marginBottom: '8px'
  },
  contactExtraInfo: {
    marginTop: 4,
    padding: 6
  },

  accordion: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: '8px !important',
    border: 'none',
    '&.Mui-expanded': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.white_100.main,
      margin: '0 !important',
      marginBottom: '8px !important'
    },
    '&::before': {
      display: 'none' // Remove o pseudo-elemento
    },
    '& .MuiAccordionSummary-root': {
      borderRadius: '8px',
      minHeight: '30px'
    },
    '& svg': {
      color: theme.palette.blue_300.main
    },
    '& .MuiAccordionSummary-content': {
      margin: '0'
    },
    marginBottom: '8px' // optional: adds some spacing between accordions
  },
  accordionSummary: {
    borderRadius: '8px',
    '&.Mui-expanded': {
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0'
    },
    '& .MuiIconButton-root': {
      padding: 0
    }
  },
  accordionDetails: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    display: 'flex',
    flexDirection: 'column',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px'
  },
  accordionTitle: {
    color: theme.palette.blue_300.main,
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  groupParticipantsLoading: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: '8px 0'
  },
  groupParticipantsList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  groupParticipantItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  groupParticipantAvatar: {
    width: '32px',
    height: '32px',
    fontSize: '12px'
  },
  groupParticipantInfo: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  groupParticipantName: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '13px',
    fontWeight: '500',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  groupParticipantNumber: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_500.main
        : theme.palette.gray_300.main,
    fontSize: '12px'
  },
  groupParticipantsEmpty: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_500.main
        : theme.palette.gray_300.main,
    fontSize: '13px'
  },

  tagsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginTop: '8px'
  },
  tag: {
    color: theme.palette.white_100.main,
    fontSize: '10px',
    fontWeight: '500',
    textTransform: 'uppercase',
    borderRadius: '4px',
    height: '18px'
  },
  extraInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  },

  extraInfoButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    '& button': {
      width: '100%',
      borderRadius: '8px',
      border: '1px solid' + theme.palette.blue_300.main,
      color: theme.palette.blue_300.main,
      textTransform: 'capitalize'
    },
    '& button:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  buttonDelete: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    '& button': {
      width: '100%',
      borderRadius: '8px'
    }
  },
  buttonRemove: {
    backgroundColor: theme.palette.red_100.main,
    color: theme.palette.white_100.main,
    display: 'flex',
    gap: '12px',
    marginTop: '12px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.gray_400.main,
      boxShadow: 'none'
    }
  },

  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
